import { FieldValidator } from './field-validator'

export class LengthTextFieldValidator implements FieldValidator<string> {
    constructor(private textLength: number, private isOptional = false) {}

    validate(text: string, fieldName: string): Promise<string> {
        const invalidPhoneNumberMessage = `${fieldName} must be exactly ${this.textLength} numbers`

        const isUndefined: boolean = !text
        const isEmpty: boolean = !!text && text.length === 0
        const isTheWrongLength: boolean = !!text && text.toString().length !== this.textLength

        return new Promise((resolve, reject) => {
            if (this.isOptional && (isUndefined || isEmpty)) {
                resolve('')
            } else if (isUndefined || isTheWrongLength) {
                reject(invalidPhoneNumberMessage)
            } else {
                resolve('')
            }
        })
    }
}
